/**
 * @description: 单据设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="store-set-bill">
        <!-- 账单商品明细是否合并设置 -->
        <div class="store-bmg-set" v-show="show1">
            <div class="bmg-list">
                <h1 class="title">账单商品明细是否合并设置</h1>
                <p class="p-hint">注：【否】账单会显示商品的销售，退货的每一笔的明细。【是】账单内一样的商品只显示一条，退货商品不显示，退款金额不显示。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="bmgList" style="margin-top: 10px"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(1)">返回</button>
                </div>
            </div>
        </div>


        <!-- 交接单金额为0元是否显示 -->
        <div class="store-jdj-set" v-show="show2">
            <div class="jdj-list">
                <h1 class="title">交接单金额为0元是否显示</h1>
                <p class="p-hint">注：交接单各支付方式金额为0元的默认是显示，如不想显示金额为0的支付方式设置成否</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="jdjList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(2)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单预定信息是否可修改 -->
        <div class="store-zyx-set" v-show="show3">
            <div class="zyx-list">
                <h1 class="title">账单预定信息是否可修改</h1>
                <p class="p-hint">注：清扫后账单预定信息是否可修改，默认是可修改，如不需要修改则设置成否。</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zyxList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(3)">返回</button>
                </div>
            </div>
        </div>


        <!-- 账单内低消商品增加‘低’的标记 -->
        <div class="store-zdd-set" v-show="show4">
            <div class="zdd-list">
                <h1 class="title">账单内低消商品增加‘低’的标记</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="zddList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(4)">返回</button>
                </div>
            </div>
        </div>


        <!-- 送花账单明细是否合并设置 -->
        <div class="store-szmh-set" v-show="show5">
            <div class="szmh-list">
                <h1 class="title">送花账单明细是否合并设置</h1>
                <p class="p-hint">注：【否】送花账单会显示送花、退花每一笔明细。【是】送花账单同一员工同一种花只显示一条结果，送花、退花合并</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover" data-pagination="true" ref="szmhList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIndex(5)">返回</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false,
            }
        },
        watch: {
            
        },
        mounted: function() {
            
        },
        methods: {
            // 显示页面
            showTargetPage(num) {
                this[`show${num}`] = true

                if(num == '1') {
                    this.innitBmgTable()
                } else if(num == '2') {
                    this.innitJdjTable()
                } else if(num == '3') {
                    this.innitZyxTable()
                } else if(num == '4') {
                    this.innitZddTable()
                } else if(num == '5') {
                    this.innitSzmhTable()
                }
            },
            // 返回
            backIndex(index) {
                this[`show${index}`] = false
                this.$emit('targetBack')
            },


            /*
             * 账单商品明细是否合并设置
             */
            // 初始化账单商品明细是否合并设置列表
            innitBmgTable: function() {
                let _this = this;
                $(_this.$refs.bmgList).bootstrapTable('destroy');
                $(_this.$refs.bmgList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.geBmgList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "bill_detail_merge",
                        title: "账单显示商品明细是否合并",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let bill_detail_merge = $(this).children('option:selected').val();
                                _this.bmgSub(row.shop_id, bill_detail_merge, row.print_bill_detail_merge);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.bill_detail_merge == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "print_bill_detail_merge",
                        title: "账单单据打印显示商品明细是否合并",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let print_bill_detail_merge = $(this).children('option:selected').val();
                                _this.bmgSub(row.shop_id, row.bill_detail_merge, print_bill_detail_merge);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.print_bill_detail_merge == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 账单商品明细是否合并设置列表
            geBmgList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "shop/getBillDetailMergeSetting",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 账单商品明细是否合并设置
            bmgSub: function(shop_id, bill_detail_merge, print_bill_detail_merge) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                            "bill_detail_merge": bill_detail_merge,
                            "print_bill_detail_merge": print_bill_detail_merge
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/setBillDetailMergeSetting",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.bmgList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 交接单金额为0元是否显示
             */
            innitJdjTable: function() {
                let _this = this;
                $(_this.$refs.jdjList).bootstrapTable('destroy')
                $(_this.$refs.jdjList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getJdjList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "shift_turnover_setting",
                        title: "交接单金额为0元是否显示",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.jdjSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(row.shift_turnover_setting == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            getJdjList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": "shift_turnover_setting"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            jdjSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "shift_turnover_setting"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/upConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('设置成功');
                            $(_this.$refs.jdjList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 账单预定信息是否可修改
             */
            innitZyxTable: function() {
                let _this = this;
                $(_this.$refs.zyxList).bootstrapTable('destroy');
                $(_this.$refs.zyxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getZyxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "up_bill_book",
                        title: "账单预定信息是否可修改",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.zyxSub(row.id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getZyxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopConfigList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 设置
            zyxSub: function(id, check_stock) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "up_bill_book": check_stock
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setShopConfig",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.zyxList).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },


            /*
             * 账单内低消商品增加‘低’的标记
             */
            innitZddTable: function() {
                let _this = this;
                $(_this.$refs.zddList).bootstrapTable('destroy');
                $(_this.$refs.zddList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getZddList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "minimum_consumption_tab",
                        title: "账单内低消商品增加‘低’的标记",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.zddSub(row.shop_id, check_stock);
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='-1'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='-1' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getZddList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'minimum_consumption_tab'
                        }
                    },
                    "comment": ""
                })
                .then(function(res) {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(function(error) {
                    layer.msg("出错啦");
                });
            },
            // 设置
            zddSub: function(id, check_stock) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": "minimum_consumption_tab"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        $(_this.$refs.zddList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },


            /*
             * 送花账单明细是否合并设置
             */
            innitSzmhTable: function() {
                let _this = this;
                $(_this.$refs.szmhList).bootstrapTable('destroy');
                $(_this.$refs.szmhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzmhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "30%"
                    }, {
                        field: "merge_flower_bill",
                        title: "送花账单明细显示是否合并设置",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.szmhSub(row.shop_id, check_stock, 'merge_flower_bill');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }, {
                        field: "merge_flower_info_bill_print",
                        title: "送花账单单据打印明细是否合并",
                        width: "30%",
                        events: {
                            'change .select-sel': function(e, value, row) {
                                let check_stock = $(this).children('option:selected').val();
                                _this.szmhSub(row.shop_id, check_stock, 'merge_flower_info_bill_print');
                            }
                        },
                        formatter: function(value, row, index) {
                            let strHtml = "";
                            if(value == "1") {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1' selected>是</option><option value='2'>否</option></select>";
                            } else {
                                strHtml = "<select class='select-sel select2 ct-select'><option value='1'>是</option><option value='2' selected>否</option></select>";
                            }
                            return strHtml;
                        }
                    }]
                });
            },
            // 列表
            getSzmhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                Vue.axios.post('Shop/getConfigList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "config_type": 'merge_flower_data'
                        }
                    },
                    "comment": ""
                })
                .then(function(res) {
                    if(res.data.response.result_code == "true") {
                        params.success({
                            total: res.data.response.result.count,
                            rows: res.data.response.result.data
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(function(error) {
                    layer.msg("出错啦");
                });
            },
            // 设置
            szmhSub: function(id, check_stock, config_type) {
                const _this = this;

                Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,
                            "config": check_stock,
                            "config_type": config_type
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        $(_this.$refs.szmhList).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
        }
    }
</script>
<style lang="less" scoped>

</style>